import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center px-4 pt-24 pb-16 overflow-hidden" data-id="element-112">
      <div className="absolute inset-0 bg-gradient-radial from-amber-500/10 via-transparent to-transparent opacity-50" data-id="element-113" />

      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8
    }} className="max-w-5xl mx-auto text-center relative z-10" data-id="element-114">
        <motion.h1 initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-4xl md:text-5xl lg:text-6xl font-black leading-tight mb-6 bg-gradient-to-r from-white via-amber-50 to-white bg-clip-text text-transparent" data-id="element-115">
          Cómo Ganar Tus Primeros $2,000 Extra al Mes Usando IA — Sin Hablar
          Inglés Perfecto, Sin Saber Programar y Trabajando Solo 15 Minutos al
          Día.
        </motion.h1>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-lg md:text-xl text-gray-300 mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-116">
          El sistema exacto que los latinos en USA están usando para procesar
          servicios de $500 en minutos y dejar atrás los trabajos físicos
          agotadores para siempre.
        </motion.p>

        <motion.a href="https://aifreelancegoldmine.com/cart/46344678604961:1" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} className="relative inline-block bg-gradient-to-r from-amber-500 to-amber-600 text-black font-bold text-lg px-10 py-5 rounded-full shadow-2xl hover:shadow-amber-500/50 transition-all duration-300" data-id="element-117">
          <motion.span animate={{
          opacity: [1, 0.7, 1]
        }} transition={{
          duration: 2,
          repeat: Infinity
        }} className="absolute inset-0 bg-amber-400 rounded-full blur-xl opacity-50" data-id="element-118" />
          <span className="relative" data-id="element-119">
            SÍ, QUIERO EMPEZAR MI GOLDMINE — ACCESO INMEDIATO POR $47
          </span>
        </motion.a>
      </motion.div>
    </section>;
}